(() => {

  const CASE_VARIANTS = {

    'iPhone® 17 Pro': '7085689110819',

    'iPhone® 17 Pro Max': '7085689143587'

  };
 
  let chosenPhone = null;

  let syncQueued = false;
 
  const block = () => document.querySelector('kaching-bundles-block');
 
  const selectedBar = () =>

    block()?.querySelector('.kaching-bundles__bar--selected');
 
  function phoneFromSelect(select) {

    return select?.options[select.selectedIndex]?.text.trim() ||

      select?.dataset.value?.trim() ||

      null;

  }
 
  function nativePhone() {

    for (const [phone, value] of Object.entries(CASE_VARIANTS)) {

      if (document.querySelector(

        `input[type="radio"][value="${value}"]:checked`

      )) {

        return phone;

      }

    }

    return null;

  }
 
  function bundleSelects() {

    const bar = selectedBar();

    if (!bar) return {};
 
    const products = [

      ...bar.querySelectorAll(

        '.kaching-bundles__bundle-products__product'

      )

    ];
 
    const lensProduct = products.find(product =>

      product.querySelector(

        'a[href*="/products/lens-protector-iphone-17-pro-promax"]'

      )

    );
 
    const caseProduct = products.find(product =>

      product !== lensProduct &&

      product.querySelector('select[data-name="Phone"]')

    );
 
    return {

      caseSelect: caseProduct?.querySelector(

        'select[data-name="Phone"]'

      ),

      lensSelect: lensProduct?.querySelector(

        'select[data-name="Phone"]'

      )

    };

  }
 
  function setSelectPhone(select, phone) {

    if (!select || !phone || phoneFromSelect(select) === phone) return;
 
    const option = [...select.options].find(

      item => item.text.trim() === phone

    );

    if (!option) return;
 
    select.selectedIndex = option.index;

    select.dispatchEvent(new Event('change', { bubbles: true }));

  }
 
  function setNativePhone(phone) {

    const value = CASE_VARIANTS[phone];

    if (!value || nativePhone() === phone) return;
 
    const input = document.querySelector(

      `input[type="radio"][value="${value}"]`

    );

    if (!input) return;
 
    const label = document.querySelector(

      `label[for="${CSS.escape(input.id)}"]`

    );
 
    (label || input).click();

  }
 
  function sync() {

    const bar = selectedBar();

    if (!bar) return;
 
    const { caseSelect, lensSelect } = bundleSelects();
 
    if (caseSelect) {

      if (chosenPhone) setSelectPhone(caseSelect, chosenPhone);
 
      const currentPhone = phoneFromSelect(caseSelect);

      if (!currentPhone) return;
 
      chosenPhone = currentPhone;

      setSelectPhone(lensSelect, currentPhone);

    } else if (chosenPhone) {

      // Case Only uses Shopify's regular product variant picker.

      setNativePhone(chosenPhone);

    }

  }
 
  function queueSync() {

    if (syncQueued) return;

    syncQueued = true;
 
    requestAnimationFrame(() => {

      syncQueued = false;

      sync();

    });

  }
 
  // Capture the choice before Kaching replaces the selected offer.

  document.addEventListener('click', event => {

    const newBar = event.target.closest(

      'kaching-bundles-block .kaching-bundles__bar'

    );
 
    if (!newBar || newBar === selectedBar()) return;
 
    const { caseSelect } = bundleSelects();

    chosenPhone =

      phoneFromSelect(caseSelect) ||

      nativePhone() ||

      chosenPhone;
 
    setTimeout(queueSync, 0);

    setTimeout(queueSync, 100);

  }, true);
 
  document.addEventListener('change', event => {

    const { caseSelect } = bundleSelects();
 
    if (event.target === caseSelect) {

      chosenPhone = phoneFromSelect(caseSelect);

      queueSync();

      return;

    }
 
    if (

      event.target.matches?.('input[type="radio"]') &&

      Object.values(CASE_VARIANTS).includes(event.target.value)

    ) {

      chosenPhone = nativePhone();

      queueSync();

    }

  }, true);
 
  function start() {

    const kb = block();

    if (!kb) {

      setTimeout(start, 250);

      return;

    }
 
    new MutationObserver(queueSync).observe(kb, {

      childList: true,

      subtree: true,

      attributes: true,

      attributeFilter: ['class']

    });
 
    chosenPhone = phoneFromSelect(bundleSelects().caseSelect) ||

      nativePhone();
 
    queueSync();

  }
 
  start();

})();
 